Auth = require 'app/scripts/db/auth'
Alerts = require 'app/scripts/views/lib/alerts'
ApiError = require 'app/scripts/network/api-error'
PostRender = require 'app/scripts/views/lib/post-render'
Promise = require 'bluebird'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
$ = require 'jquery'
assert = require 'app/scripts/lib/assert'
f = require 'effing'
log = require 'app/scripts/debug/log'
makeErrorEnum = require 'app/scripts/lib/make-error-enum'
moment = require 'moment'
ninvoke = require 'app/scripts/lib/util/ninvoke'
{ Apdex } = require '@trello/atlassian-analytics'
{ track } = require '@trello/analytics'
{ ErrorViews } = require 'app/common/data/error-views'

DisplayBoardError = makeErrorEnum 'DisplayBoard', [
  'ConfirmToView'
  'CardNotFound'
  'CardNotFoundOnThisBoard'
  'BoardNotFound'
]

boardCache = (idBoard) -> "board_#{idBoard}"

QUERY_PARAMS = [
  'menu',
  'filter',
  'openListComposer',
  'openCardComposerInFirstList'
]

fireAndForgetExtraBoardDataLoad = (idBoardOrShortLink, requiredDataPromise) ->
  # Dependency required at call site to avoid import cycles, do not lift to top of module
  ModelLoader = require 'app/scripts/db/model-loader'
  requiredDataPromise ?= Promise.resolve()

  # Note that we should try to use the same id that would be used in
  # quickload, i.e. the shortLink
  loadSecondary = ModelLoader.for('top-level', 'loadBoardSecondary', idBoardOrShortLink)
  loadPluginData = ModelLoader.for('top-level', 'loadBoardPluginData', idBoardOrShortLink)

  Promise.all([
    loadSecondary,
    loadPluginData
  ])
  .catch ApiError, (->)
  .done()
  return

loadBoardData = (idBoardOrShortLink, loadLabels) ->
  # Dependency required at call site to avoid import cycles, do not lift to top of module
  ModelLoader = require 'app/scripts/db/model-loader'
  requiredDataPromise =
    if loadLabels
      ModelLoader.for 'top-level', 'loadCurrentBoardWithLabelData', idBoardOrShortLink
    else
      ModelLoader.for 'top-level', 'loadCurrentBoardData', idBoardOrShortLink

  # The browser may limit how many concurrent requests we can make, so do
  # the secondary ones after the first one has started
  fireAndForgetExtraBoardDataLoad(idBoardOrShortLink, requiredDataPromise)

  requiredDataPromise
  .catch ApiError.Unconfirmed, -> Promise.reject DisplayBoardError.ConfirmToView()
  .catch ApiError, -> Promise.reject DisplayBoardError.BoardNotFound()

getRenderLock = ->
  PostRender.hold()
  Promise.resolve().disposer -> PostRender.release()

module.exports =
  showCardOnBoard: (idCard, highlight, board, replyToComment, loadCardData) ->
    Promise.try ->
      if (card = board.getCard(idCard))?
        # We're making the assumption here that if we can find the card, then we
        # don't need to call loadCardData.  If we don't have e.g.
        # the idBoard, idList or name then we know for sure that we've
        # violated that assumption.
        assert card.get('idBoard')? && card.get('idList')? && card.get('name')?,
          "Tried to display a card that was only partially loaded"
        card
      else
        loadCardData idCard
        .tap (card) ->
          if card.get('idBoard') != board.id
            Promise.reject(DisplayBoardError.CardNotFoundOnThisBoard('', { idBoard: board.id }))
          return
    .then (card) =>
      @showCardDetail card, { highlight, replyToComment }

  showBoardDetailView: (args, boardView) -> Promise.try =>
    board = boardView.model

    if (idCard = args.idCard)?
      @showCardOnBoard idCard, args.highlight, board, args.replyToComment, args.loadCardData
    else if args.usernameBoardProfile &&
            (member = board.modelCache.findOne 'Member', 'username', args.usernameBoardProfile)?
      boardView.showMemberProfile(member)
    else if args.section in ['power-up', 'power-ups']
      if board.editable()
        boardView.showDirectory(args.directorySection, args.directoryCategory, args.directoryIdPowerUp, args.directoryIsEnabling)
      else
        @setBoardLocation(board.id)
    else if args.section == 'map'
      boardView.showMap()
    else if (date = args.calendarDate)?
      boardView.showCalendar date
    else if args.section == 'butler'
      boardView.showButler()
    else
      if args.openListComposer
        boardView.openListComposer()
      if args.openCardComposerInFirstList
        # Deferred to ensure "Add a card" button below composer is hidden properly
        _.defer -> boardView.openCardComposerInFirstList()
      @setBoardLocation(board.id, args.section)

  renderBoard: (board, options) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    BoardView = require 'app/scripts/views/board/board-view'
    Promise.resolve if @onBoardView(board.id)
      boardView = @existingTopLevelView(BoardView, board)
      boardView.closeDetailView()
      boardView
    else
      @clearPreviousView()
      @setViewType(board)
      @showHeader(@headerOptsForBoard(board))
      @maybeShowFooterChrome(@getBoardUrl(board.id))

      boardView = @topLevelView BoardView, board, _.extend(options, {
        modelCache: board.modelCache
        headerBranding: => @headerBranding(@headerOptsForBoard(board))
      })

      $('#content').html(boardView.render().el)
      $('#trello-root').addClass('body-board-view')

      boardView

  headerOptsForBoard: (board) ->
    organization = board.getOrganization()
    if organization?.get('idEnterprise')? && organization?.getEnterprise()?
      enterprise = organization.getEnterprise()
      {
        headerBrandingColor: enterprise.get('prefs')?.brandingColor
        headerBrandingLogo: enterprise.getHeaderLogo()
        headerBrandingName: enterprise.get('displayName')
      }
    else
      {}

  settingsFromQuery: ->
    _.chain(location.search.substr(1).split('&'))
      .map (entry) -> entry.split('=', 2)
      .filter ([key]) ->
        key in QUERY_PARAMS
      .map ([key, value]) ->
        [key, decodeURIComponent(value)]
      .object()
      .value()

  displayBoard: (settings) ->
    log('controller', ['boardView', settings.idBoard])

    { idBoard, idCard } = settings
    assert idBoard || idCard,
      "Illegal invocation of displayBoard: requires one of idBoard, or idCard"
    if (idCard? && !Util.checkId(idCard) && !Util.isShortLink(idCard)) ||
    (idBoard? && !Util.checkId(idBoard) && !Util.isShortLink(idBoard))
      return Promise.resolve @displayErrorPage {
        errorType: ErrorViews.MALFORMED_URL
      }

    Promise.using getRenderLock(), =>
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      ModelLoader = require 'app/scripts/db/model-loader'
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      ModelCache = require 'app/scripts/db/model-cache'
      # [LOADCARD]
      loadCardData = _.once (idCardOrShortLink) ->
        ModelLoader.for 'top-level', 'loadCardData', idCardOrShortLink
        .catch ApiError, -> Promise.reject(DisplayBoardError.CardNotFound())

      awaitView = ({ model }) =>
        new Promise (resolve) =>
          @waitForId model, resolve

      # Allow settings object values to also be provided via query params
      queryParams = @settingsFromQuery()
      loadLabels = queryParams.filter?.startsWith('label:') || false
      detailArgs = _.extend({ loadCardData }, settings, queryParams)

      startTime = Date.now()
      apdexTask = if idCard? then 'card' else 'board'
      apdexTaskId = idCard ? idBoard

      Apdex.start(
        task: apdexTask,
        taskId: apdexTaskId,
      )

      Promise.using @getSpinner(), =>
        ModelLoader.release('top-level')
        Promise.try =>
          if idCard?
            # If we're showing a card, we always want to load the data for it
            return loadCardData(idCard).call('get', 'idBoard')
          idBoard
        .then (idBoard) ->
          Promise.props
            loadStartTime: Date.now()
            board: loadBoardData(idBoard, loadLabels)
            timingLabel:
              if ModelLoader.getUpToDateBoard(idBoard)?
                "Known Board"
              else
                "New Board"
        .then ({ board, timingLabel, loadStartTime }) =>
          loadDuration = Date.now() - startTime
          track("Timing", "Load", timingLabel, loadDuration)

          renderStartTime = Date.now()

          @renderBoard board, {
            section: detailArgs.section,
            settings:
              filter: detailArgs.filter,
              menu: detailArgs.menu,
          }
          .tap ->
            loadAndRenderDuration = Date.now() - startTime
            renderDuration = Date.now() - renderStartTime
            track("Timing", "Load and Render", timingLabel, loadAndRenderDuration)
            track("Timing", "Render", timingLabel, renderDuration)
          .tap awaitView
          .then f(@, 'showBoardDetailView', detailArgs)
          .tap ->
            Apdex.stop(
              task: apdexTask,
              taskId: apdexTaskId,
            )

        .catch DisplayBoardError.ConfirmToView, =>
          assert Auth.isLoggedIn(), "Got 401: 'Confirm to view' while not logged in"
          ninvoke ModelCache, 'waitFor', 'Member', Auth.myId()
          .then =>
            @displayErrorPage _.extend
              errorType: ErrorViews.UNCONFIRMED_BOARD_NOT_FOUND
            , Auth.me().toJSON()

        .catch DisplayBoardError.CardNotFound, =>
          @displayErrorPage
            errorType: ErrorViews.CARD_NOT_FOUND

        .catch DisplayBoardError.BoardNotFound, =>
          @displayErrorPage
            errorType: ErrorViews.BOARD_NOT_FOUND

        .catch DisplayBoardError.CardNotFoundOnThisBoard, ({ idBoard }) =>
          Alerts.show('card does not exist', 'warning', 'doesnotexist', 5000)
          @setBoardLocation(idBoard, settings.section)

# [LOADCARD]
#
# It's probable that we'll need to do two data loads in order to load the
# board: one to determine what board the card lives on, and another to load
# the card.
#
# It's *possible*, if bizarre QuickLoad race conditions play in our favor,
# that doing the naive thing will just *happen* to work -- if the timing
# is just right, QuickLoad will give us the same response back twice, and
# two calls create only one actual network request.
#
# But. Let's memoize it ourself just in case, so that we don't have to worry
# about QuickLoad's behavior changing and doubling the requests here.
